export default "__VITE_ASSET__W3MnTU9v__"